export const countryCode = (locale: string) => locale.split('-')[1].toUpperCase();
